import { useState } from "react";
import { styled as muiStyled } from "@mui/material/styles";

import { TextField } from "@mui/material";
// import MuiButton from "@mui/material/Button";
import MuiDialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import Button from "src/components/core/Button";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const Dialog = muiStyled(MuiDialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 24,
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(3),
    border: 0,
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
  },
}));

function extractYouTubeVideoId(url) {
  const match = url.match(
    /(?:\?v=|\/embed\/|\/v\/|\/vi\/|\/u\/\w\/|\/embed\/|\/v\/|watch\?v=|&v=|youtu\.be\/)([^#?&]+)/
  );
  return match && match[1];
}

function extractTikTokVideoId(url) {
  const match = url.match(/\/video\/(\d+)/);
  return match && match[1];
}

const AddEmbedLinkModal = ({ onClose, onSubmit }) => {
  const [url, setURL] = useState("");

  const isValidVideoURL = url;

  const getEmbedURL = (url) => {
    const source = url.includes("tiktok") ? "tiktok" : "youtube";
    let embedURL = "";

    if (source === "tiktok") {
      const vdoId = extractTikTokVideoId(url);
      embedURL = `https://www.tiktok.com/embed/${vdoId}`;
    } else if (source === "youtube") {
      const vdoId = extractYouTubeVideoId(url);
      embedURL = `https://www.youtube.com/embed/${vdoId}`;
    }

    return embedURL;
  };

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={true}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: 425,
          },
        },
      }}
    >
      <DialogTitle>
        แนบลิงค์วีดีโอเนื้อหา
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          label="Video URL"
          variant="outlined"
          required
          value={url}
          onChange={(e) => setURL(e.target.value)}
          fullWidth
          autoFocus
          helperText={"e.g. https://www.youtube.com/embed/VZ9wtP6hjz8"}
        />
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          size="large"
          onClick={onClose}
          sx={{ minWidth: 140 }}
        >
          ยกเลิก
        </Button>
        <Button
          variant="contained"
          size="large"
          onClick={() => onSubmit(getEmbedURL(url))}
          disabled={!isValidVideoURL}
          sx={{ minWidth: 140 }}
        >
          ยืนยัน
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddEmbedLinkModal;
